module.exports = __webpack_public_path__ + "media/audio13.40338e03.wav";